/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkin_Qr_ErrorInputs */



/**
* | output |
* | --- |
* | "Invalid check-in code" |
*
* @param {Checkin_Qr_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const checkin_qr_error = /** @type {((inputs?: Checkin_Qr_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkin_Qr_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code de pointage invalide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de check-in inválido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Código de check-in inválido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice di check-in non valido")
	return /** @type {LocalizedString} */ ("Invalid check-in code")
});